import IMG1 from './assets/img/projects/password-app.png'
import IMG2 from './assets/img/projects/number-mngmnt.png'
import IMG3 from './assets/img/projects/memories.png'
import IMG4 from './assets/img/projects/blog.png'
import IMG5 from './assets/img/projects/keeper-app-react.png'
import IMG6 from './assets/img/projects/todo-app-nodejs.png'
import IMG7 from './assets/img/projects/weather.png'
import IMG8 from './assets/img/projects/hoobank.png'
import CERT1 from './assets/img/certificates/NodeJS.jpg'
import CERT2 from './assets/img/certificates/WebDev.jpg'
import CERT3 from './assets/img/certificates/js.png'
import CERT4 from './assets/img/certificates/frontend.png'
import CERT5 from './assets/img/certificates/python.png'


export const data = [
    {
        id: 1,
        image: IMG3,
        title: 'Memories Social Network (React)',
        github: 'https://github.com/artikov/memories-web-app',
        demo: 'https://memories-artikov.netlify.app/'
    },
    {
        id: 2,
        image: IMG5,
        title: 'Keeper App (React)',
        github: 'https://github.com/artikov/keeper-clone',
        demo: 'https://keeper-app-artikov.herokuapp.com/'
    },
    {
      id: 3,
      image: IMG6,
      title: 'Todo List App (JavaScript)',
      github: 'https://github.com/artikov/todo-list',
      demo: 'https://todo-list-artikov.herokuapp.com/'
    },
    {
      id: 4,
      image: IMG2,
      title: 'Contact Management using CRUD (JavaScript)',
      github: 'https://github.com/artikov/contact-management',
      demo: ' https://contact-management-artikov.herokuapp.com/'
    },
    {
      id: 5,
      image: IMG4,
      title: 'Personal Blog (Python & Flask)',
      github: 'https://github.com/artikov/personal-blog',
      demo: 'https://oybek-blog.herokuapp.com/'
    },
    {
      id: 6,
      image: IMG7,
      title: 'Weather App (JavaScript)',
      github: 'https://github.com/artikov/weather-app-js',
      demo: 'https://artikov.github.io/weather-app-js/'
    },
    {
      id: 7,
      image: IMG1,
      title: 'Password App (Python)',
      github: 'https://github.com/artikov/',
    },
    {
      id: 8,
      image: IMG8,
      title: 'Bank Application (React & TailwindCSS)',
      github: 'https://github.com/artikov/modern-bank-ui',
      demo: 'https://artikov-bank.netlify.app/'
    },
  ]


export const certificates = [
    {
      id: 1,
      image: CERT2,
      title: 'Web Development',
      subtitle: 'App Brewery'
    },
    {
      id: 2,
      image: CERT3,
      title: 'Programming with Java Script',
      subtitle: 'Meta'
    },
    {
        id: 3,
        image: CERT5,
        title: 'Python Pro Bootcamp',
        subtitle: 'App Brewery'
    },
    {
        id: 4,
        image: CERT4,
        title: 'Front End development',
        subtitle: 'Udemy'
    },
    {
        id: 5,
        image: CERT1,
        title: 'NodeJS & Express',
        subtitle: 'Udemy'
    },
  ]
